import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8b44d460"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "卡包还没拆完，现在退出页面系统会自动拆包哦", -1));
const _hoisted_2 = {
  class: "btns"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showBack,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.showBack = $event),
    "close-on-click-overlay": false,
    class: "popup-back-box"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "btn-item btn-item-l",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args))
    }, "仍然退出页面"), _createElementVNode("div", {
      class: "btn-item btn-item-r",
      onClick: _cache[1] || (_cache[1] = $event => $options.showBack = false)
    }, "继续拆包")])])]),
    _: 1
  }, 8, ["show"]);
}